import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Partners = lazy(() => import("@/pages/Partners"));

export const Route = createFileRoute("/_public/partners")({
  component: Partners,
});
